var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageSquareLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0013 5.3335H4.0013V6.66683H12.0013V5.3335Z",
    fill: "#1F2939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66797 8.00016H4.0013V9.3335H8.66797V8.00016Z",
    fill: "#1F2939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3346 1.3335H0.667969V13.3335H4.0013V15.5363L7.52583 13.3335H15.3346V1.3335ZM14.0013 2.66683V12.0002H7.14344L5.33464 13.1307V12.0002H2.0013V2.66683H14.0013Z",
    fill: "#1F2939"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSquareLines);
export default __webpack_public_path__ + "static/media/message-square-lines.f517bc8a9ec2f21cc8060ee7a1109c2d.svg";
export { ForwardRef as ReactComponent };